import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export function createStore(baseState) {
	return new Vuex.Store({
		state: baseState,
		getters: {
			page: state => state.route ? parseInt(state.route.params.page) || 1 : undefined,
			areaUrlCode: state => state.route ? state.route.params.areaUrlCode || undefined : undefined,
			searchQuery: state => state.route ? state.route.query.searchQuery || undefined : undefined,
		},
		mutations: {
			pageCount(state, value) {
				state.pageCount = value;
			}
		}
	});
}